module.exports = __webpack_public_path__ + "static/media/MU_Landing_Page_SC_16x9.8082d851.vtt";